import React, {ReactNode, useMemo} from 'react'
import {PHOTO_RATIO} from '../../config/constants'
import {floatToStr} from '../../helpers/coreUtil'
import styles from './ImageContainer.scss'

// 横縦3:2の比率にしたい時に使用
//always 100% width
const ImageContainer = (
  {
    isTall,
    children,
    ratio,
  }: {
    isTall?: boolean
    children: ReactNode
    ratio?: number
  }) => {
  const style = useMemo(() => ratio !== undefined && {
    overflow: 'hidden',
    paddingBottom: `${floatToStr(isTall
      ? 100 * (ratio || PHOTO_RATIO)
      : 100 / (ratio || PHOTO_RATIO))}%`
  }, [isTall, ratio])
  return <div
    className={[
      'w-100 position-relative',
      ratio === undefined && styles.imageContainer,
      ratio === undefined && isTall && styles.tall
    ].filter(Boolean).join(' ')}
    {...style && { style}}
  >
    <div className="w-100 h-100 position-absolute">
      {children}
    </div>
  </div>
}
ImageContainer.displayName = 'ImageContainer'
export default ImageContainer
